/**
 *
 * FilterLayout
 *
 */

import React from 'react';

import Button from 'components/common/Button';

import './style.css';
// import styled from 'styled-components';

/**
 * UI component for rendering buttons related to clear, cancel or applying the filter along with the children passed.
 * */
const FilterLayout = ({ onCancel, onApply, onClear, ...rest }: any): any => (
  <div className="container">
    <div className="filter-layout-filter-position">
      <div className="filterBox">
        {rest.children}
        <div className="filterContainer">
          {onClear && (
            <Button
              className="clear"
              text="Clear"
              onClick={onClear}
              {...rest}
            />
          )}
          {onCancel && (
            <Button
              className="cancel"
              text="Cancel"
              onClick={onCancel}
              {...rest}
            />
          )}
          {onApply && (
            <Button text="Apply" type="primary" onClick={onApply} {...rest} />
          )}
        </div>
      </div>
    </div>
  </div>
);

export default FilterLayout;
